
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-leaf-line',
      title: '環保永續',
      description: '採用最新的綠色建築技術，包括太陽能發電、雨水回收系統和節能建材，打造零碳排放社區。',
      image: 'https://public.readdy.ai/ai/img_res/88e9f46a7da8bc9945c2abdccef85844.jpg'
    },
    {
      icon: 'ri-community-line',
      title: '社區生活',
      description: '完善的社區設施包括健身中心、兒童遊樂場、社區花園和多功能活動中心，促進鄰里互動。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20community%20center%20with%20playground%2C%20fitness%20facilities%2C%20garden%20spaces%2C%20people%20enjoying%20outdoor%20activities%2C%20tropical%20setting%2C%20family-friendly%20environment%2C%20contemporary%20architecture%2C%20vibrant%20community%20life&width=600&height=400&seq=community-feature&orientation=landscape'
    },
    {
      icon: 'ri-road-map-line',
      title: '便利交通',
      description: '優越的地理位置，距離石垣機場僅10分鐘車程，完善的道路網絡連接市中心和主要景點。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20transportation%20infrastructure%20in%20Okinawa%2C%20well-planned%20roads%2C%20convenient%20access%20to%20airport%2C%20urban%20planning%2C%20tropical%20island%20setting%2C%20clean%20modern%20design%2C%20efficient%20traffic%20flow&width=600&height=400&seq=transport-feature&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全保障',
      description: '24小時安全監控系統、緊急應變機制和完善的防災設施，確保居民生活安全無憂。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20security%20system%2C%20safe%20residential%20community%2C%20surveillance%20technology%2C%20emergency%20facilities%2C%20well-lit%20pathways%2C%20secure%20environment%2C%20professional%20safety%20infrastructure%2C%20peaceful%20neighborhood&width=600&height=400&seq=security-feature&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '健康生活',
      description: '配備健康步道、有機農園和運動中心，推廣健康的生活方式，密集海空航班連結台灣醫療資源，時刻守護每位居民的健康。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20wellness%20facilities%2C%20health%20center%2C%20yoga%20studio%2C%20organic%20garden%2C%20walking%20trails%2C%20fitness%20areas%2C%20healthy%20lifestyle%20amenities%2C%20tropical%20wellness%20resort%20atmosphere&width=600&height=400&seq=health-feature&orientation=landscape'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '教育資源',
      description: '鄰近優質學校和教育機構，提供從幼兒園到高中的完整教育體系，培育下一代人才。社區結合自然生態導覽、日英中三語課程，打造「教育＋度假+投資」複合社區。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20educational%20facilities%2C%20school%20buildings%2C%20learning%20environment%2C%20children%20studying%2C%20educational%20resources%2C%20contemporary%20architecture%2C%20bright%20classrooms%2C%20academic%20excellence&width=600&height=400&seq=education-feature&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">項目特色</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            我們致力於打造一個集現代化、投資、旅遊於一體的理想社區，為居民提供全方位的優質生活體驗。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-64 object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="lg:w-1/2 text-center lg:text-left">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto lg:mx-0 mb-4">
                  <i className={`${feature.icon} text-teal-600 text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
